import { getApps, initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import store from '../store/store';

function initialOrganizationFirebase(organization) {
	//const organization = store.getters.getOrganization;

	const firebaseConfig = {
		apiKey: organization.apiKey,
		authDomain: organization.authDomain,
		projectId: organization.projectId,
		storageBucket: organization.storageBucket,
		messagingSenderId: organization.messagingSenderId,
		appId: organization.appId,
		measurementId: organization.measurementId,
	};

	const app = getApps().find((x) => x.name === organization.projectId);

	if (app) {
		return app;
	} else {
		// Initialize Firebase
		const app = initializeApp(firebaseConfig, organization.projectId);
		return app;
	}
}

function getOrganizationStorage(organization) {
	const app = initialOrganizationFirebase(organization);
	//Storage
	const storage = getStorage(app);

	return storage;
}

function getOrganizationFirestore(organization) {
	const app = initialOrganizationFirebase(organization);
	// Firestore
	const firestore = getFirestore(app);

	return firestore;
}

export { getOrganizationStorage, getOrganizationFirestore };